import React, { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { Warehouse, ArrowLeftRight, Pencil, Check } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Stock del producto por depósito (ficha del producto). Se oculta si la empresa no usa depósitos. */
export default function StockDepositosTabla({ token, productoId, stockMinimo = 0, puedeTransferir, puedeEditarUbicacion, onTransferir, refreshKey }) {
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };
  const [data, setData] = useState(null);
  const [editando, setEditando] = useState(null); // clave fila
  const [valor, setValor] = useState("");

  const cargar = useCallback(async () => {
    const r = await fetch(`${API}/admin/depositos/stock/${productoId}`, { headers });
    setData(r.ok ? await r.json() : null);
  }, [productoId, token]); // eslint-disable-line
  useEffect(() => { cargar(); }, [cargar, refreshKey]);

  if (!data || !data.activo) return null;
  const k = (f) => `${f.deposito_id}|${f.variante_id || ""}`;
  const guardar = async (f) => {
    const r = await fetch(`${API}/admin/depositos-ubicacion`, {
      method: "PUT", headers,
      body: JSON.stringify({ producto_id: productoId, variante_id: f.variante_id || null, deposito_id: f.deposito_id, ubicacion: valor }),
    });
    if (!r.ok) { const e = await r.json().catch(() => ({})); toast.error(e.detail || "No se pudo guardar"); return; }
    setEditando(null); cargar();
  };

  return (
    <div className="border border-white/10 rounded-xl p-3 mt-3">
      <div className="flex items-center justify-between mb-2">
        <p className="text-slate-300 text-xs font-medium flex items-center gap-2"><Warehouse className="w-3.5 h-3.5 text-cyan-400" /> Stock por depósito</p>
        {puedeTransferir && (
          <button onClick={() => onTransferir && onTransferir(data.filas)} className="text-xs px-2.5 py-1 rounded-lg bg-white/10 text-white hover:bg-white/15 flex items-center gap-1">
            <ArrowLeftRight className="w-3 h-3" /> Transferir
          </button>
        )}
      </div>
      <table className="w-full text-xs">
        <thead className="text-slate-500"><tr>
          <th className="text-left py-1">Depósito</th>{data.filas.some(f => f.variante_texto) && <th className="text-left">Variante</th>}
          <th className="text-left">Ubicación</th><th className="text-right">Stock</th>
        </tr></thead>
        <tbody>
          {data.filas.map(f => (
            <tr key={k(f)} className="border-t border-white/5">
              <td className="py-1.5 text-white">{f.codigo} · {f.deposito}</td>
              {data.filas.some(x => x.variante_texto) && <td className="text-slate-400">{f.variante_texto || "—"}</td>}
              <td className="text-slate-400">
                {editando === k(f) ? (
                  <span className="flex items-center gap-1">
                    <input autoFocus value={valor} onChange={e => setValor(e.target.value)} onKeyDown={e => e.key === "Enter" && guardar(f)}
                      className="w-32 bg-arandu-dark border border-white/10 rounded px-2 py-0.5 text-white outline-none" placeholder="Pasillo / estante" />
                    <button onClick={() => guardar(f)} className="text-emerald-400"><Check className="w-3.5 h-3.5" /></button>
                  </span>
                ) : (
                  <span className="flex items-center gap-1">{f.ubicacion || "—"}
                    {puedeEditarUbicacion && <button onClick={() => { setEditando(k(f)); setValor(f.ubicacion || ""); }} className="text-slate-500 hover:text-white"><Pencil className="w-3 h-3" /></button>}
                  </span>
                )}
              </td>
              <td className={`text-right font-semibold ${f.cantidad <= 0 ? "text-red-300" : (stockMinimo > 0 && f.cantidad <= stockMinimo ? "text-orange-300" : "text-white")}`}>{f.cantidad}</td>
            </tr>
          ))}
        </tbody>
        <tfoot><tr className="border-t border-white/10"><td className="py-1.5 text-slate-400" colSpan={data.filas.some(f => f.variante_texto) ? 3 : 2}>Total</td><td className="text-right text-white font-semibold">{data.total}</td></tr></tfoot>
      </table>
    </div>
  );
}
